import { useFullTrack } from '../../tracks';
import { useTrackAwardProgress } from '../../userProgress';
import { useMostRecentExamAttempt } from '../examsQueries';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { useUserInfo } from '../../accounts';
import { LANGUAGE_STRINGS } from '../../../components/Languages';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import TrackViewAwardLink from '../../../components/TrackCard/TrackViewAwardLink';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Section } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import FinishedContainer from '../../../components/FinishedContainer';
import RetakeExamButton from './RetakeExamButton';
import ExamLoadingScreen from './ExamLoadingScreen';
import ExamErrorScreen from './ExamErrorScreen';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getPassDate(mostRecentExamAttempt, award) {
  if (mostRecentExamAttempt) {
    return mostRecentExamAttempt.attemptFinishTime;
  }
  if (award) {
    return award.awardedAt;
  }
  return null;
}
export default function ExamLinkedLanguage({
  trackId,
  trackAwardId,
  language,
  linkedLanguage
}) {
  const {
    track
  } = useFullTrack(trackAwardId, linkedLanguage);
  const {
    award
  } = useTrackAwardProgress(Number(trackAwardId));
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackAwardId), linkedLanguage);
  const {
    userInfo,
    userInfoLoading,
    userInfoError
  } = useUserInfo();
  const passDateForLinkedLanguageExam = getPassDate(mostRecentExamAttempt, award);
  const {
    isTablet
  } = useMediaQuery();
  const loading = userInfoLoading || mostRecentExamAttemptLoading;
  const error = userInfoError || mostRecentExamAttemptError;
  if (loading) {
    return /*#__PURE__*/_jsx(ExamLoadingScreen, {});
  }
  if (error) {
    return /*#__PURE__*/_jsx(ExamErrorScreen, {
      error: error
    });
  }
  const ctaText = /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "learningCenter.exams.finished.retakeButtonLinkedLanguage",
    options: {
      language: LANGUAGE_STRINGS[language]
    }
  });
  return /*#__PURE__*/_jsx(FinishedContainer, {
    body: /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(H3, {
        "data-test-id": "exam-linked-language-heading",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.exams.finished.successHeading",
          options: {
            firstName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.user.firstName
          }
        })
      }), /*#__PURE__*/_jsx(Section, {
        "data-test-id": "exam-linked-language-subheading",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.exams.finished.passedOnSubHeadingLinkedTrack",
          options: {
            courseName: track === null || track === void 0 ? void 0 : track.name,
            linkedLanguage: LANGUAGE_STRINGS[linkedLanguage],
            language: LANGUAGE_STRINGS[language],
            passDate: passDateForLinkedLanguageExam ? /*#__PURE__*/_jsx(FormattedDateTime, {
              format: "ll",
              value: passDateForLinkedLanguageExam
            }) : null
          }
        })
      }), /*#__PURE__*/_jsx(Section, {
        "data-test-id": "exam-linked-language-callToAction",
        children: /*#__PURE__*/_jsx(TrackViewAwardLink, {
          award: award,
          certification: true,
          trackId: trackAwardId
        })
      })]
    }),
    footer: isTablet ? /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "stretch",
        flexDirection: "column",
        children: /*#__PURE__*/_jsx(RetakeExamButton, {
          ctaText: ctaText,
          language: language,
          trackId: trackId,
          use: "tertiary-light",
          withTooltip: true
        })
      })
    }) : /*#__PURE__*/_jsx(RetakeExamButton, {
      ctaText: ctaText,
      language: language,
      trackId: trackId,
      use: "tertiary-light",
      withTooltip: true
    }),
    illustration: /*#__PURE__*/_jsx(Illustration, {
      name: "trophy"
    })
  });
}